import { object, string } from 'yup'
import {
  setEnrollFormError,
  setFormError,
  setReduxValue,
  setFormNextButtonDisabled,
  setDisableSubmit,
} from '.'
import { checkIdCard, isValidateDate, saveDebounce } from 'src/utils/lib'
import _ from 'lodash'
import { userType } from 'src/components/UpdateProfileDialog/UpdateProfileForm/model'

export async function handleFormInput(
  currentState,
  originalState,
  index,
  listenerApi
) {
  const enroll = currentState.body.enroll[index]
  const isConsentChecked = currentState.consent === true

  // ดึง userType มาจาก localStorage
  const user = JSON.parse(localStorage.getItem('user') ?? '{}')
  const isAgent = user?.userType === userType.AGENT
  // const isCS =
  //   _.get(user, 'distributionChannel.abbreviation', '') === userType.CS
  const staffType = _.get(user, 'staffProfile.type', null)
  const nonAcademy = staffType === 'NON_ACADEMY'
  const isStaffAcademy =
    user?.userType === userType.STAFF && staffType !== 'NON_ACADEMY'
  const isStaffNonAcademy =
    user?.userType === userType.STAFF && staffType === 'NON_ACADEMY'
  const isProspect = user?.userType === userType.PROSPECT

  // Staff Non Academy and Prospect: All fields required except email
  const isAllFieldsRequired = isStaffNonAcademy || isProspect

  console.log('handleFormInput isAgent ->>', isAgent)

  let validateInputSchema = object().shape({
    prefixTH: string().when([], {
      is: () => {
        // Agent: required, Staff Non Academy: required, Prospect: required, others: not validated
        return isAgent || isAllFieldsRequired
      },
      then: string().required('กรุณาเลือกคำนำหน้าชื่อ'),
      otherwise: string().nullable(),
    }),
    firstNameTH: string().when([], {
      is: () => {
        // Staff Non Academy: required, Prospect: required, others: not validated
        return isAllFieldsRequired
      },
      then: string().required('กรุณากรอกชื่อ'),
      otherwise: string().nullable(),
    }),
    lastNameTH: string().when([], {
      is: () => {
        // Staff Non Academy: required, Prospect: required, others: not validated
        return isAllFieldsRequired
      },
      then: string().required('กรุณากรอกนามสกุล'),
      otherwise: string().nullable(),
    }),
    prefix: string().when([], {
      is: () => {
        // Staff Non Academy: required, Prospect: required, others: not validated
        return isAllFieldsRequired
      },
      then: string().required('กรุณาเลือกคำนำหน้าชื่อภาษาอังกฤษ'),
      otherwise: string().nullable(),
    }),
    firstName: string().when([], {
      is: () => {
        // Staff Non Academy: required, Prospect: required, others: not validated
        return isAllFieldsRequired
      },
      then: string().required('กรุณากรอกชื่อภาษาอังกฤษ'),
      otherwise: string().nullable(),
    }),
    lastName: string().when([], {
      is: () => {
        // Staff Non Academy: required, Prospect: required, others: not validated
        return isAllFieldsRequired
      },
      then: string().required('กรุณากรอกนามสกุลภาษาอังกฤษ'),
      otherwise: string().nullable(),
    }),
    idCardNo: string().when([], {
      is: () => {
        // Staff Academy: required, Staff Non Academy: required, Prospect: required, Non Academy: required
        return isStaffAcademy || isStaffNonAcademy || isProspect || nonAcademy
      },
      then: string().required('กรุณากรอกเลขบัตรประชาชน'),
      otherwise: string().nullable(),
    }),
    mobileNo: string().when([], {
      is: () => {
        // Staff Non Academy: required, Prospect: required, Non Academy: required
        return isAllFieldsRequired || nonAcademy
      },
      then: string().required('กรุณากรอกเบอร์มือถือ'),
      otherwise: string().nullable(),
    }),
    birthDate: string().when([], {
      is: () => {
        // Staff Academy: required, Staff Non Academy: required, Prospect: required, Non Academy: required
        return isStaffAcademy || isStaffNonAcademy || isProspect || nonAcademy
      },
      then: string().required('กรุณากรอกวันเกิด'),
      otherwise: string().nullable(),
    }),
  })

  let inputValid = true

  try {
    await validateInputSchema.validate(enroll, { abortEarly: false })
  } catch (e) {
    inputValid = false
  }

  const shouldDisable = !inputValid || !isConsentChecked
  if (originalState.formNextButtonDisabled[index] !== shouldDisable) {
    listenerApi.dispatch(
      setFormNextButtonDisabled({ index, value: shouldDisable })
    )
    listenerApi.dispatch(setDisableSubmit(!shouldDisable))
  }
}

export async function handleFormNextStep(
  currentState,
  originalState,
  index,
  listenerApi
) {
  const enroll = currentState.body.enroll[index]
  const user = JSON.parse(localStorage.getItem('user'))
  const isAgent = user.userType === userType.AGENT
  const isCS =
    _.get(user, 'distributionChannel.abbreviation', '') === userType.CS
  const staffType = _.get(user, 'staffProfile.type', null)
  const nonAcademy = staffType === 'NON_ACADEMY'
  const isStaffAcademy =
    user.userType === userType.STAFF && staffType !== 'NON_ACADEMY'
  const isStaffNonAcademy =
    user.userType === userType.STAFF && staffType === 'NON_ACADEMY'
  const isProspect = user.userType === userType.PROSPECT

  // Staff Non Academy and Prospect: All fields required except email
  const isAllFieldsRequired = isStaffNonAcademy || isProspect

  // Helper function to check if date is before today
  const isDateBeforeToday = (dateStr) => {
    if (!dateStr) return false
    const date = new Date(dateStr)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return date < today
  }

  console.log('handleFormInput isAgent ->>', isAgent)

  const validateInputSchema = object().shape({
    prefixTH: string()
      .default('')
      .when('$isAgent', {
        is: true,
        then: string().required('กรุณาเลือกคำนำหน้าชื่อ'),
        otherwise: string().when('$isAllFieldsRequired', {
          is: true,
          then: string().required('กรุณาเลือกคำนำหน้าชื่อ'),
          otherwise: string().nullable(),
        }),
      })
      .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร'),

    firstNameTH: string()
      .default('')
      .when('$isAgent', {
        is: true,
        then: string().nullable(), // AGENT: ไม่ต้อง validate
        otherwise: string().when('$isAllFieldsRequired', {
          is: true,
          then: string()
            .required('กรุณากรอกชื่อ')
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[ก-๙\s]+$/, 'กรุณากรอกชื่อภาษาไทยเท่านั้น'),
          otherwise: string()
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[ก-๙\s]+$/, 'กรุณากรอกชื่อภาษาไทยเท่านั้น')
            .nullable(),
        }),
      }),

    lastNameTH: string()
      .default('')
      .when('$isAgent', {
        is: true,
        then: string().nullable(), // AGENT: ไม่ต้อง validate
        otherwise: string().when('$isAllFieldsRequired', {
          is: true,
          then: string()
            .required('กรุณากรอกนามสกุล')
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[ก-๙\s]+$/, 'กรุณากรอกนามสกุลภาษาไทยเท่านั้น'),
          otherwise: string()
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[ก-๙\s]+$/, 'กรุณากรอกนามสกุลภาษาไทยเท่านั้น')
            .nullable(),
        }),
      }),

    prefix: string()
      .default('')
      .when('$isAgent', {
        is: true,
        then: string().nullable(),
        otherwise: string().when('$isAllFieldsRequired', {
          is: true,
          then: string().required('กรุณาเลือกคำนำหน้าชื่อภาษาอังกฤษ'),
          otherwise: string().nullable(),
        }),
      }),

    firstName: string()
      .default('')
      .when('$isAgent', {
        is: true,
        then: string().nullable(),
        otherwise: string().when('$isAllFieldsRequired', {
          is: true,
          then: string()
            .required('กรุณากรอกชื่อภาษาอังกฤษ')
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[A-Za-z\s]+$/, 'กรุณากรอกชื่อภาษาอังกฤษเท่านั้น'),
          otherwise: string()
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[A-Za-z\s]+$/, 'กรุณากรอกชื่อภาษาอังกฤษเท่านั้น')
            .nullable(),
        }),
      }),

    lastName: string()
      .default('')
      .when('$isAgent', {
        is: true,
        then: string().nullable(),
        otherwise: string().when('$isAllFieldsRequired', {
          is: true,
          then: string()
            .required('กรุณากรอกนามสกุลภาษาอังกฤษ')
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[A-Za-z\s]+$/, 'กรุณากรอกนามสกุลภาษาอังกฤษเท่านั้น'),
          otherwise: string()
            .max(255, 'กรอกได้ไม่เกิน 255 ตัวอักษร')
            .matches(/^[A-Za-z\s]+$/, 'กรุณากรอกนามสกุลภาษาอังกฤษเท่านั้น')
            .nullable(),
        }),
      }),

    idCardNo: string()
      .default('')
      .when('$isNeedIdCard', {
        is: true,
        then: string()
          .required('กรุณากรอกเลขประจำตัวประชาชน')
          .max(13, 'กรอกได้ไม่เกิน 13 ตัวอักษร')
          .test(
            'idCardNo-test',
            'กรุณากรอกเลขประจำตัวประชาชนให้ถูกต้อง',
            (val) => checkIdCard(val)
          ),
        otherwise: string().nullable(),
      }),

    mobileNo: string()
      .default('')
      .when('$isNeedMobile', {
        is: true,
        then: string()
          .required('กรุณากรอกหมายเลขโทรศัพท์มือถือ')
          .max(10, 'กรอกได้ไม่เกิน 10 ตัวอักษร')
          .test(
            'mobile-test',
            'กรุณากรอกหมายเลขโทรศัพท์มือถือให้ถูกต้อง',
            (val) => val?.length === 10 && /^[0-9]+$/.test(val)
          ),
        otherwise: string().nullable(),
      }),

    birthDate: string()
      .default('')
      .when('$isNeedBirthDate', {
        is: true,
        then: string()
          .required('กรุณากรอกวันเกิด')
          .test('date-format-test', 'กรุณากรอกวันที่ให้ถูกต้อง', (val) =>
            isValidateDate(val)
          )
          .test(
            'date-before-today',
            'กรุณากรอกวันที่เกิดที่ผ่านมาแล้ว',
            (val) => isDateBeforeToday(val)
          ),
        otherwise: string().nullable(),
      }),
  })
  try {
    await validateInputSchema.validate(enroll, {
      abortEarly: false,
      context: {
        isAgent,
        isCS,
        isStaffAcademy,
        isStaffNonAcademy,
        isAllFieldsRequired,
        isNeedIdCard:
          isStaffAcademy || isStaffNonAcademy || isProspect || nonAcademy,
        isNeedMobile: isAllFieldsRequired || nonAcademy,
        isNeedBirthDate:
          isStaffAcademy || isStaffNonAcademy || isProspect || nonAcademy,
      },
    })
    listenerApi.dispatch(setFormError({ index: index, value: [] }))
    if (originalState.enrollFormError[index]) {
      saveDebounce(() =>
        listenerApi.dispatch(setEnrollFormError({ index: index, value: false }))
      )
    }
  } catch (e) {
    listenerApi.dispatch(setFormError({ index: index, value: e.inner }))
    if (!originalState.enrollFormError[index]) {
      saveDebounce(() =>
        listenerApi.dispatch(setEnrollFormError({ index: index, value: true }))
      )
    }
  }
}

export function handleStep2Button(listenerApi) {
  const formNextButtonDisabled =
    listenerApi.getState().eLearningEnroll.formNextButtonDisabled
  listenerApi.dispatch(
    setReduxValue({
      index: 'nextButtonDisabled',
      value: formNextButtonDisabled[0],
    })
  )
}

export function handleStep3Button(listenerApi) {
  const consent = listenerApi.getState().eLearningEnroll.consent
  listenerApi.dispatch(
    setReduxValue({ index: 'nextButtonDisabled', value: !consent })
  )
}
